import {combineReducers} from '@reduxjs/toolkit';
import {withReduxStateSync} from 'redux-state-sync';
import ui from '~/redux/ui/slice';
import auth from '~/redux/auth/slice';
import apps from '~/redux/apps/slice';
import admins from '~/redux/admins/slice';
import questionnaires from '~/redux/questionnaires/slice';
import testimonials from '~/redux/testimonials/slice';

const appReducer = combineReducers({
  ui,
  apps,
  auth,
  admins,
  questionnaires,
  testimonials,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined;
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;

export default withReduxStateSync(rootReducer);
